module.exports = __webpack_public_path__ + "img/6e2f0.88744cf7.svg";